import { generatePath } from 'react-router-dom';

import { COMPANY_PATH } from 'constants/paths';

// get the company route for a specific slug
const getCompanyRoute = (slug) => generatePath(COMPANY_PATH, { id: slug });

export default getCompanyRoute;
